module.exports = __webpack_public_path__ + "img/05.746a11af.png";